module.exports = __webpack_public_path__ + "static/img/login-background.1ff60e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LNI/login-background.png
// module id = b6g1
// module chunks = 0